import React from 'react';
import { InputText } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import Alert from '../shared/Alert/Alert';
import { FORM_KEYS } from '../../constants/formKeys';
import { VALIDATION_ERROR_MESSAGE } from '../../constants/errorMessage';
import { transformToNumbersOnly } from '../../utils/formatString';

const maskedEmail = (email) => {
  if (!email) return '';
  const [username = '', domain] = email.split('@');
  const maskedUsername = `${username.slice(0, 1)}${'*'.repeat(Math.max(username.length - 1, 0))}`;
  return domain ? `${maskedUsername}@${domain}` : maskedUsername;
};
const maskedPhone = (phone) => {
  if (!phone) return '';
  const lastThreeDigits = phone.slice(-3);
  return `****${lastThreeDigits}`;
};

const VERIFY_CODE_LENGTH = 6;

const VerifyCode = ({
  title,
  type = 'email',
  typeValue,
  handleSendCode,
  handleVerifyCode,
  isCodeSent,
  errorMessage,
  timeLeft
}) => {
  const formContext = useFormContext();
  const { VERIFY_EMAIL_CODE, VERIFY_PHONE_CODE } = FORM_KEYS;
  const isVerifyEmail = type === 'email';
  const verificationCodeInputName = isVerifyEmail ? VERIFY_EMAIL_CODE : VERIFY_PHONE_CODE;
  const maskedEmailAndPhone = isVerifyEmail ? maskedEmail(typeValue) : maskedPhone(typeValue);

  const handleChange = (e) => {
    const { value } = e.target;
    const numberOnly = transformToNumbersOnly(value);
    formContext.setValue(verificationCodeInputName, numberOnly);
  };

  return (
    <>
      {title && <h1 className="pageTitle">{title}</h1>}
      {isCodeSent && !errorMessage && (
        <Alert
          type="success"
          message={`Verification code has been sent to your ${isVerifyEmail ? 'email address.' : 'mobile phone'}`}
        />
      )}
      {errorMessage && (
        <Alert
          type="error"
          message={errorMessage}
        />
      )}

      <p>Please enter the 6-digit code sent to {maskedEmailAndPhone}. This code expires in 5 minutes.</p>

      <InputText
        customChangeHandler={handleChange}
        maxLength={VERIFY_CODE_LENGTH}
        name={verificationCodeInputName}
        label="Verification code"
        customCssClass="verifyCodeInput"
        validation={{
          minLength: {
            value: VERIFY_CODE_LENGTH,
            message: VALIDATION_ERROR_MESSAGE.ENTER_A_VALID_CODE
          }
        }}
        fieldFormContext={formContext}
      />
      <div className="buttonGroupContainer">
        <button
          className="button inverse secondary"
          type="button"
          onClick={handleSendCode}
          disabled={isCodeSent && timeLeft > 0}
        >
          Resend Code {isCodeSent && timeLeft > 0 && `(${timeLeft})`}
        </button>
        <button
          className="button"
          type="button"
          onClick={handleVerifyCode}
          disabled={type === 'email' ? !formContext.watch(VERIFY_EMAIL_CODE) : !formContext.watch(VERIFY_PHONE_CODE)}
        >
          Verify Code
        </button>
      </div>
    </>
  );
};

export default VerifyCode;

VerifyCode.propTypes = {
  type: PropTypes.oneOf(['email', 'sms']).isRequired,
  typeValue: PropTypes.string,
  title: PropTypes.string,
  isCodeSent: PropTypes.bool,
  errorMessage: PropTypes.string,
  handleSendCode: PropTypes.func.isRequired,
  handleVerifyCode: PropTypes.func.isRequired,
  timeLeft: PropTypes.number
};
